/* eslint-env browser */

import merge from 'lodash/merge';
import isString from 'lodash/isString';
import { syncWithCis } from '@spt-tracking/pulse-cis-sync';

import device from './_device';

export * from './_device';

export default function (input) {
  var _ref = input || {},
      actor = _ref.actor,
      deviceData = _ref.device;

  var _ref2 = isString(actor) ? { id: actor } : actor || {},
      userId = _ref2.id;

  var data = isString(deviceData) ? { id: deviceData } : deviceData;

  return syncWithCis(userId).then(function (_ref3) {
    var jwe = _ref3.jwe,
        environmentId = _ref3.environmentId;

    data = merge({
      id: environmentId,
      jweIds: jwe
    }, data);

    return device({ device: data });
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/device-browser.js
// module id = 524
// module chunks = 0